<template>
  <div class="placeSearch" id="placeSearch">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'placeSearch'
}
</script>

<style scoped>
.placeSearch {
  width: 100%;
  height: 100%;
}
</style>
